import styled from "styled-components";

export const ViewSwitch = ({
    firstOptionName, firstOptionValue, firstOptionIcon,
    secondOptionName, secondOptionValue, secondOptionIcon,
    selected,
    onChange
}) => {

    let isSwitched = true;
    if(firstOptionValue === selected) isSwitched = false;

    const clickHandler = () => {
        if(isSwitched) onChange?.(firstOptionValue);
        else onChange?.(secondOptionValue)
    }

    return (
        <StyledViewSwitch onClick={clickHandler} className={isSwitched ? 'isSwitched' : null}>
            <div className="option">
                {firstOptionIcon}
                {firstOptionName}
            </div>
            <div className="option">
                {secondOptionIcon}
                {secondOptionName}
            </div>
            <div className="selector">
                <div/>
            </div>
        </StyledViewSwitch>
    )
}

const StyledViewSwitch = styled.div`
    height: 32px;
    user-select: none;

    background: ${({theme}) => theme.colors.mutedBackground};
    border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
    border-radius: ${({theme}) => theme.cornerRadius.md};
    padding: 2px;

    cursor: pointer;

    display: inline-grid;
    grid-template-columns: 1fr 1fr;
    position: relative;

    div.option
    {
        height: 100%;
        padding: 0 ${({theme}) => theme.spacing.md};
        display: flex;
        align-items: center;
        justify-content: center;
        gap: ${({theme}) => theme.spacing.sm};
        position: relative;
        z-index: 1000;

        .icon
        {
            font-size: ${({theme}) => theme.iconSize.sm};
        }
    }

    div.selector
    {
        position: absolute;
        height: 100%;
        width: 50%;
        top: 0;
        left: 0;
        padding: 2px;
        transition-duration: 110ms;

        > div
        {
            border: 1px solid blue;
            height: 100%;
            width: 100%;
            background: ${({theme}) => theme.colors.neutralPrimaryBackground};
            border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
            border-radius: ${({theme}) => theme.cornerRadius.sm};
        }
    }

    &.isSwitched div.selector
    {
        transform: translateX(100%);
    }
`